/**
 * @file 无数据
 * @author alfielv
 */
import React from 'react';
import classNames from 'classnames';
import { PREFIX_CLS } from '../../constants';
import './index.css';
var prefixCls = "".concat(PREFIX_CLS, "-no-data");
;

var NoData = function NoData(props) {
  var className = props.className,
      content = props.content;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(prefixCls, className)
  }, /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefixCls, "__contents")
  }, content));
};

NoData.defaultProps = {
  content: '暂无相关数据记录'
};
export default NoData;